/* eslint-disable no-param-reassign */
/* eslint-disable react/sort-comp */
import React, { Component } from "react";
import {
	Button,
	Table,
	TableContainer,
	TableHead,
	TableHeader,
	TableBody,
	TableRow,
	Pagination,
	Loading,
	FileUploader,
	ComposedModal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	TableCell,
	TableToolbar,
	DataTableSkeleton,
	TableSelectRow,
	DataTable,
	TableToolbarContent,
	TableBatchActions,
	TableBatchAction,
	Tabs,
	Tab,
} from "carbon-components-react";
import moment from "moment";
import { Link } from "react-router-dom";
import View16 from "@carbon/icons-react/lib/view--filled/16";
import Add16 from "@carbon/icons-react/lib/add/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import "../../scss/custom.scss";
import Edit16 from "@carbon/icons-react/lib/edit/16";
import Send16 from "@carbon/icons-react/lib/send/16";
import { CheckmarkOutline16, Error16, Export16, Download16 } from "@carbon/icons-react/lib/";
import { switchDateFormat } from "../../helpers/jsonschemaform/customwidget/utils";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getError, STATUS, getSuccess, apioperation, entitiesLabels, CarType, GetCarTypeByCode } from "../../helpers/Constants";
import { api, registry, audit } from "../../helpers/api/api";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import AuditCARModal from "./AuditCARModal";
import { ConfirmAlertCustom } from "../../helpers/ConfirmAlertCustom";
import { CanExecuteAction, IsEditable } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import { WFActionModal } from "../common/WFActionModal";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import AuditRepository from "../../helpers/api/AuditRepository";
import { Online, Offline } from "../common/OnLineOffLine";
import ExportDoc16 from "@carbon/icons-react/lib/document--export/16";
import FileDownLoadButton from "../common/FileDownloadButton";

export default class AuditCARList extends Component {
	initialState = (props) => {
		const idAuditEdit = props ? props.match.params.id : "";
		const idAnswer = props ? props.match.params.idAnswer : "";
		const isNewCarManagement = props ? Number(props.match.params.newMng) : 0;

		const initialState = {
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			idAuditEdit,
			idAnswer,
		    isNewCarManagement,
			isLoading: true,
			auditEditModel: null,
			isSubmitted: false,
			isLoadingFindingFile: false,

			// modal insert/edit
			keyModalCAR: `modalCAR_${new Date().getTime()}`,
			editModelCAR: null,
			isEditModalCAR: false,
			isOpenModalCAR: false,
			isOpenDeleteModal: false,
			isDeleting: false,
			idToDelete: false,
			// ---import/export----
			isOpenModalUploadTemplate: false,
			//--------------------
			auditModel: {
				id: null,
				idAnswer: null,
				auditCAR: [],
			},
			searchModel: {
				carType: CarType.NC.Code,
			},
			appStatus: null,
			appType: null,

			currentPage: 1,
			//pageSize: 10,
			//RITM0549692
			pageSize: 20,
			rowCount: 0,
		};
		return initialState;
	};

	constructor(props) {
		super(props);

		this.updateState = this.updateState.bind(this);
		// this.handleChangeCombo = this.handleChangeCombo.bind(this);
		this.state = {
			...this.initialState(props),
		};
		
		this.baseUrl = this.state.idAnswer ? `${this.state.idAuditEdit}/answer/${this.state.idAnswer}/car/` : `${this.state.idAuditEdit}/car/`;
		this.repository = new AuditRepository();
	}

	baseUrl;

	componentDidMount() {
		this.getStatus();
		this.getCARs();
		this.getLevel();
	}

	showLoading() {
		const show = (this.state.isEdit && this.state.isLoading) || this.state.isSubmitted;
		const descr = this.state.isSubmitted ? "Saving..." : "Loading data...";
		return show && <Loading active withOverlay description={descr} />;
		// return (<InlineLoading className="bx--loading-overlay" {...props} />)
	}

	getCARs() {
		this.setState({
			isLoading: true,
		});

		let data = {
			params: {
				page: this.state.currentPage,
				pageSize: this.state.pageSize,
				...this.state.searchModel,
			},
		};
		audit.getWithParam(this.baseUrl, data)
			.then((response) => {
				const { data } = response;
				if (data) {
					this.setState({
						auditModel: {
							auditCode: data.auditCode,
							id: data.id,
							idAnswer: data.idAnswer,
							audit: data.audit,
							auditCAR: data.auditCAR.itemList,
						},
						currentPage: data.auditCAR.currentPage,
						pageSize: data.auditCAR.pageSize,
						pageCount: data.auditCAR.pageCount,
						rowCount: data.auditCAR.rowCount,
					});
				} else {
					showNotification.error(`${entitiesLabels.ERROR}`, "CARs not found");
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.STATUS, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoading: false,
				});
			});
	}

	getLevel = async () => {
		const levels = await this.repository.getLevels();
		const appTypes = levels.itemList?.filter((lv) => lv.inUse).map((l) => l.name);
		this.setState({
			appType: appTypes,
		});
	};

	getStatus = () => {
		registry
			.getAll("status")
			.then((response) => {
				const { data } = response;
				// data = data != null ? data.filter(item => (item.id == 1 || item.id == 4)) : [];
				this.setState({
					appStatus: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.STATUS, apioperation.GET));
			})
			.finally(() => {});
	};

	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;

		this.setState(statusCopy);
	};

	handleChangeDP = (value, text, event) => {
		const inputName = event.element.name;
		const objName = event.element.alt;

		if (value == null || value[0] == null) {
			this.updateState(inputName, null, objName);
			return;
		}

		let date = value[0];
		if (typeof date === "object") {
			date = switchDateFormat(date, "JSdate");
		}

		this.updateState(inputName, date, objName);
	};

	handleChangeDPInput = (event) => {
		try {
			if (event == null || event.target == null) return null;
			const inputName = event.target.name;
			const objName = event.target.alt;
			if (event.target.value == null) {
				this.updateState(inputName, null, objName);
				return;
			}

			let date = event.target.value;
			const s = date.split("/");
			if (s.length < 3) return;

			const dd = s[0];
			const mm = s[1];
			const yy = s[2];
			if (dd.length < 2 || mm.length < 2 || yy.length < 4) return;

			date = `${yy}-${mm}-${dd}`;

			this.updateState(inputName, date, objName);
			return;
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.UPLOAD));
			return null;
		}
	};

	/** ********CAR******************* */

	toggleModalCAR = (open) => {
		this.setState({ isOpenModalCAR: open });
	};

	addCar = () => {
		this.setState({ keyModalCAR: `modalCAR_${new Date().getTime()}` });
		this.setState({ isEditModalCAR: false, isOpenModalCAR: true, editModelCAR: null });
	};

	editModalCAR = (id) => {
		this.setState({ keyModalCAR: `modalCAR_${new Date().getTime()}` });
		const item = this.state.auditModel.auditCAR.find((el) => el.id == id);
		this.setState({ editModelCAR: item, isEditModalCAR: true, isOpenModalCAR: true });
	};

	handleSaveModalCAR = (datiForm) => {
		// showNotification.warning("TODO Validazione su CARModal.js");

		if (!datiForm) return;

		this.setState({
			isSubmitted: true,
		});

		if (!this.state.isEditModalCAR) {
			datiForm.idAudit = this.state.idAuditEdit;
			datiForm.idAnswer = this.state.idAnswer;
		}
		const postBackUrl = `${datiForm.idAudit}/answer/${datiForm.idAnswer}/car/`;
		const method = this.state.isEditModalCAR ? audit.put(postBackUrl, datiForm, datiForm.id) : audit.post(postBackUrl, datiForm);

		method
			.then((response) => {
				if (response.status === 200) {
					let answerSection = null;
					if (this.state.isEditModalCAR) {
						answerSection = this.state.auditModel.auditCAR[0].audit.checkList.answers;
					} else if (this.state.auditModel.auditCAR.length > 0) {
						answerSection = this.state.auditModel.audit.checkList.answers;
					} else {
						answerSection = this.state.auditModel.audit.checkList.answers;
					}
					const section = answerSection.find((el) => el.id === datiForm.idAnswer);

					// let answerCar = answerSection.find((el) => el.id === datiForm.idAnswer && el.cars != [] );
					let items = this.state.auditModel.auditCAR;
					const element = items.find((el) => el.id === datiForm.id);

					if (element == null) {
						datiForm.enabled = true;
						datiForm.idStatus = 1;
						datiForm.status = {
							id: 1,
							name: "Draft",
							planningName: "Draft",
							reportingName: "Opened",
							carManagementName: "Assigned",
						};
						var carType = 'NC';
						switch (response.carType) {
							case 'Non Conformity':
								carType = 'NC';
								break;
							case 'Observation':
								carType = 'OBS';
								break;
							case 'Suggestion For improvment':
								carType = 'SFI';
								break;
							case 'Strength':
								carType = 'STR';
								break;
						}

						datiForm.auditCARCode =
							response.data.auditCARCode != undefined
								? response.data.auditCARCode
								: "AUD_" +
								  this.state.auditModel?.audit?.sequence +
								  "_" +
								  moment.utc(this.state.auditModel.audit.createdOn, "YYYY-MM-DD  HH:mm").local().format("YYYY") +
								  "_"+ carType +"_" +
								  moment.utc(datiForm.dueDate, "YYYY-MM-DD  HH:mm").local().format("YYYY");

						console.log(datiForm.auditCARCode);
						console.log(response.data);
						datiForm.findingCode = response.data.findingCode ? response.data.findingCode : '';
						datiForm.ca = [];
						datiForm.section = `${section.section.code} ${section.section.name}`;
						items = items.concat([datiForm]);
					} else {
						items[items.indexOf(element)] = datiForm;
					}
					this.repository.updateCachedCarList(datiForm, false);
					this.setState((state) => {
						const { auditModel } = state;
						auditModel.auditCAR = items;
						state.isOpenModalCAR = false;

						return state;
					});
					this.setState({
						rowCount: this.state.rowCount + 1,
					});
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.FINDING, this.state.isEditModalCAR ? apioperation.PUT : apioperation.POST));
					this.getCARs();
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FINDING, this.state.isEditModalCAR ? apioperation.PUT : apioperation.POST));
			})
			.finally(() => {
				this.setState({
					isSubmitted: false,
				});
			});
	};

	confirmDeleteCAR = (id) => {
		this.setState({
			idToDelete: id,
			isOpenDeleteModal: true,
			isDeleting: false,
		});
	};

	onCloseConfirm = () => {
		this.setState({
			isOpenDeleteModal: false,
		});
	};

	deleteItemCAR = () => {
		const id = this.state.idToDelete;

		this.setState({
			isDeleting: true,
		});

		api.delete(this.baseUrl, id)
			.then((response) => {
				if (response.status == 200) {
					this.setState({
						idToDelete: null,
						isOpenDeleteModal: false,
					});
					this.onCloseConfirm();
					this.getCARs();
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.FINDING, apioperation.DELETE));
				} else {
					showNotification.error();
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FINDING, apioperation.DELETE));
			})
			.finally(() => {
				this.setState({
					isDeleting: false,
				});
			});
	};

	/** ********Fine CAR******************* */
	/** ********Import/Export CAR******************* */
	downloadCARTemplate = () => {
		this.setState({
			isSubmitted: true,
		});
		api.getWithParam(`/audit/${this.state.auditModel.id}/car/template`, {
			responseType: "arraybuffer",
		})
			.then((response) => {
				const data = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;
				const nomefile = "AuditFindingTemplate.xlsx";
				tempLink.setAttribute("download", nomefile);
				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CARTEMPLATE, apioperation.DOWNLOAD));
			})
			.finally(() => {
				this.setState({
					isSubmitted: false,
				});
			});
	};

	uploadCARTemplate = (event) => {
		if (this.state.statusUpload != null) {
			this.setState({
				isImportfunction: true,
				isImportCAR: true,
				message: [],
			});
			event.preventDefault();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				statusUpload: "uploading",
				// isImportCAR: true,
			}));
			const formData = new FormData();
			formData.append("FileUploaded", event.target.inputFile.files[0]);

			api.upload(`/audit/${this.state.auditModel.id}/car/template`, formData)
				.then((response) => {
					this.setState(() => ({
						canUpload: false,
						isFileValid: true,
						validationErrorTitle: "",
						validationErrorSubTitle: "",
						statusUpload: "complete",
						message: response.data,

						isImportCAR: false,
						isImportfunction: false,
					}));

					if (response.data && response.data[0] == "Success") {
						this.getCARs();
						showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CARTEMPLATE, apioperation.UPLOAD));
						this.setState(() => ({
							isOpenModalUploadTemplate: false,
						}));
					}
				})
				.catch((error) => {
					this.setState(() => ({
						canUpload: true,
						isFileValid: false,

						statusUpload: "edit",
						isImportCAR: false,
						isImportfunction: false,
						importDanger: true,
					}));
					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CARTEMPLATE, apioperation.UPLOAD));
				});
		}
	};

	onFileUploadChange = (evt) => {
		this.setState(() => ({ statusUpload: "edit" }));
		if (evt.target.files[0] && evt.target.files[0].size >= 4194304) {
			const nome = evt.target.files[0].name;
			this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: false,
				message: [],
				isFileValid: false,
				isImportCAR: false,
				validationErrorTitle: `${nome} exceeds size limit`,
				validationErrorSubTitle: "4mb max file size. Please select a new file and try again",
			}));
		} else {
			// this.fileUploader.clearFiles();
			this.setState(() => ({
				canUpload: true,
				isFileValid: true,
				validationErrorTitle: "",
				validationErrorSubTitle: "",
				message: [],
			}));
		}
	};

	toggleModalUploadTemplate = (open) => {
		this.fileUploader.clearFiles();
		this.setState({
			isOpenModalUploadTemplate: open,
			isImportHC: true,
			message: [],
			statusUpload: null,
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
			__filename: null,
		});
	};

	clearFiles = () => {
		this.fileUploader.clearFiles();
		this.setState(() => ({
			canUpload: false,
			isFileValid: true,
			validationErrorTitle: "",
			validationErrorSubTitle: "",
		}));
	};

	divMessaggImportHC() {
		return (
			<div>
				{!this.state.isImportCAR ? "" : <Loading />}

				{this.state.message[0] == "Success" ? (
					<div />
				) : (
					<div>
						{this.state.message.map((x) => (
							<div className="bx--row">
								<div className="srv-validation-message"> {x}</div>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}

	renderUploadModal = () => (
		<form onSubmit={this.uploadCARTemplate}>
			<ComposedModal className="light-modal" open={this.state.isOpenModalUploadTemplate} danger="false" onClose={() => false}>
				<ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadTemplate(false)}>
					<p>Import Findings</p>
				</ModalHeader>
				<ModalBody className="margin-modal">
					<div className="bx--file-container">
						<FileUploader
							ref={(node) => (this.fileUploader = node)}
							accept={[".xlsx"]}
							buttonKind="primary"
							buttonLabel="Choose a file"
							filenameStatus={this.state.statusUpload}
							iconDescription="Choose"
							labelTitle="Upload"
							multiple={false}
							name="inputFile"
							onClick={this.clearFiles}
							onChange={this.onFileUploadChange}
						/>
					</div>
					<div>
						{this.state.isImportHC ? this.divMessaggImportHC() : ""}
						{this.state.isImportfunction ? <Loading /> : ""}
					</div>
				</ModalBody>
				<ModalFooter>
					<Button kind="secondary" onClick={() => this.toggleModalUploadTemplate(false)}>
						Cancel
					</Button>
					<Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
						Upload
					</Button>
				</ModalFooter>
			</ComposedModal>
		</form>
	);
	/** ********Fine Import/Export CAR******************* */

	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};

	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};

	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};

	handleConfirmApprovalModal = () => {
		const apiEndpoint = this.state.approvalEndpoint;

		const data = {
			ids: this.state.selectedData.map((r) => r.id),
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};

		this.setState({
			isLoadingWFOperation: true,
		});

		let { idAnswer } = this.state;
		if (this.state.idAnswer == null) {
			const item = this.state.auditModel.auditCAR.find((el) => el.id == data.ids[0]);
			idAnswer = item.idAnswer;
		}

		api.put(`/audit/${this.state.auditModel.id}/answer/${idAnswer}/car/${apiEndpoint}`, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.AUDIT, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isLoading: true,
						auditModel: {
							auditCAR: [],
						},
					});
					this.getCARs();
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AUDIT, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};
	handleChangePaging = async (page) => {
		await new Promise((resolve) => {
			this.setState({ currentPage: page.page, pageSize: page.pageSize, loading: true, isBack: false }, resolve);
		});
		this.getCARs();
	};
	IsRowSelectable(row, selectedRows) {
		// if (!this.state.idAnswer) return false;

		var row = this.state.auditModel.auditCAR.find((i) => i.id == row.id);

		// if (row.status.id == STATUS.Consolidated) return false; //i FINDING possono essere riaperte

		if (selectedRows.length == 0) {
			return true;
		}

		if (selectedRows.length > 0) {
			const selectableAudit = this.state.auditModel.auditCAR.find((i) => i.id == selectedRows[0].id);
			const selectableState = selectableAudit.status.id;
			const selectableAnswer = selectableAudit.idAnswer;

			if (this.state.idAnswer == null) {
				if (row.status.id == selectableState && row.idAnswer == selectableAnswer) return true;
				return false;
			}
			// solo per la chiusura dei FINDING
			if (selectableState == STATUS.Approved) {
				return this.canCloseCAR(selectedRows[0].id) ? row.status.id == STATUS.Approved && this.canCloseCAR(row.id) : false;
			}
			// per il submit dei FINDING
			if (selectableState == STATUS.Draft) {
				return this.canSubmitCAR(selectedRows[0].id) ? row.status.id == STATUS.Draft && this.canSubmitCAR(row.id) : false;
			}

			if (row.status.id == selectableState) {
				return true;
			}

			return false;
		}

		return false;
	}

	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover,
			selectedData: selectedRows,
			approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired,
		});
	}

	getCanEditResourceId = (selectedRows) => {
		let canEditResource = this.state.auditModel &&
			this.state.auditModel.audit &&
			this.state.auditModel.audit.checkList && {
				idCompiler: this.state.auditModel.audit.checkList.idCompiler,
				idDataApprover: this.state.auditModel.audit.checkList.idDataApprover,
				idDivisionManager: this.state.auditModel.audit.checkList.idDivisionManager,
				email: this.state.isNewCarManagement !== 0 ? this.state.auditModel.audit.auditors.map(el => el.email) : "",
			};
		if (selectedRows && selectedRows.length > 0 && this.state.idAnswer == null) {
			const item = this.state.auditModel.auditCAR.find((el) => el.id == selectedRows[0].id);
			const { audit } = item;
			canEditResource = this.state.auditModel &&
				audit &&
				audit.checkList && {
					idCompiler: audit.checkList.idCompiler,
					idDataApprover: audit.checkList.idDataApprover,
					idDivisionManager: audit.checkList.idDivisionManager,
					email: "",
				};
		}
		if (selectedRows && selectedRows.length > 0 && canEditResource != null) {
			const car = this.state.auditModel.auditCAR.find((el) => el.id == selectedRows[0].id);
			canEditResource.email = car.owner != null ? car.owner.email : car.ownerSaipem != null ? car.ownerSaipem.email : null;
		}
		return canEditResource;
	};

	//RITM1064131
	getCanEditByPlanResourceId = (selectedRows) => {
		let canEditResource = this.state.auditModel &&
			this.state.auditModel.audit && {
				idCompiler: this.state.auditModel.audit.idCompiler,
				idDataApprover: null,
				idDivisionManager: null,
				email: "",
			};
		if (selectedRows && selectedRows.length > 0 && this.state.idAnswer == null) {
			const item = this.state.auditModel.auditCAR.find((el) => el.id == selectedRows[0].id);
			const { audit } = item;
			canEditResource = this.state.auditModel &&
				audit && {
					idCompiler: audit.idCompiler,
					idDataApprover: null,
					idDivisionManager: null,
					email: "",
				};
		}
		return canEditResource;
	};
	//End

	getStatusId = (idRow) => {
		const r = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		return r && r.idStatus;
	};

	canApproveCAR = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		const itemCa = item?.ca?.filter((x) => x.enabled);
		return item && itemCa && itemCa.length > 0;
	};

	canSubmitCAR = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		const itemCa = item?.ca?.filter((x) => x.enabled);
		return item && itemCa && itemCa.length > 0;
	};

	canCloseCAR = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		return item && item.ca && item.ca.length > 0 ? item.ca.filter((el) => el.idStatus == 4).length == item.ca.length : false;
	};

	canSubmitFinding = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		if ((item.carType === CarType.NC.Code) || (item.carType ===CarType.OBS.Code))
			return (item.ca.length > 0 ? (item.ca[0].causeOfInefficiency != null && item.ca[0].caImplemented != null && item.ca[0].dueDate != null) : false);
		else
			return false;
	}

	canOpenFinding = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		if ((item.carType === CarType.NC.Code) || (item.carType ===CarType.OBS.Code))
			return (item.ca.length > 0 ?  (item.ca[0].causeOfInefficiency != null && item.ca[0].caImplemented != null && item.ca[0].dueDate != null) : false);
		else
			return false;
	}

	canCloseFinding = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		if ((item.carType === CarType.NC.Code) || (item.carType ===CarType.OBS.Code))
			return (item.ca.length > 0 ?  (item.ca[0].immediateThreatment != null && item.ca[0].explain != null) : false);
		else
			return false;
	}

	canCompleteFinding = (idRow) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == idRow);
		if ((item.carType === CarType.NC.Code) || (item.carType ===CarType.OBS.Code))
			return (item.ca.length > 0 ? (item.ca[0].immediateThreatment != null && item.ca[0].explain != null) : false);
		else
			return false;
	}

	getUrlDetailCar = (id) => {
		if (id == null) return "#";
		if (this.state.idAnswer) return `/audit/${this.state.idAuditEdit}/${this.state.isNewCarManagement}/answer/${this.state.idAnswer}/car/${id}`; //this.baseUrl + id;
		if (!this.state.auditModel || !this.state.auditModel.auditCAR) return "#";
		const item = this.state.auditModel.auditCAR.find((el) => el.id == id);
		return `/audit/${this.state.idAuditEdit}/${this.state.isNewCarManagement}/answer/${item.idAnswer}/car/${id}#all`;
	};

	getUrlExportCar = (id) => {
		const item = this.state.auditModel.auditCAR.find((el) => el.id == id)
		return `/audit/${this.state.idAuditEdit}/answer/${item.idAnswer}/exportcar/${id}`;
	}

	setCarType = (carType) => {
		this.setState((prevState) => ({
			searchModel: { ...prevState.searchModel, carType: carType },
		}));
	};

	getCloseCaValue = (carItem) => {
		if (this.state.isNewCarManagement === 0) {
			return carItem.ca && carItem.ca.filter((el) => el.enabled == true).length > 0 ? `${carItem.ca.filter((el) => el.idStatus == 4 && el.enabled).length}/${carItem.ca.filter((el) => el.enabled == true).length}` : "";
		}
		else {
			return carItem ? `${carItem.idStatus >= 6 ? '1' : '0'}/1` : "";
		}
	};

	render() {
		let headersDataTable = [
			{ key: "auditCARCode", header: "Code" },
			{ key: "findingCode", header: "Project Finding Code" },
			{ key: "section", header: "Section" },
			{ key: "type", header: "Finding Level" },
			{ key: "status", header: "Status", type: "status" },
			{ key: "closedCa", header: "Closed CA" },
		];

		if (this.state.searchModel.carType === CarType.OBS.Code) {
			headersDataTable = [
				{ key: "auditCARCode", header: "Code" },
				{ key: "findingCode", header: "Project Finding Code" },
				{ key: "section", header: "Section" },
				{ key: "status", header: "Status", type: "status" },
				{ key: "closedCa", header: "Closed CA" },
			];
		}

		if (this.state.searchModel.carType === CarType.SFI.Code || this.state.searchModel.carType === CarType.Strength.Code) {
			headersDataTable = [
				{ key: "auditCARCode", header: "Code" },
				{ key: "findingCode", header: "Project Finding Code" },
				{ key: "section", header: "Section" },
			];
		}

		if (this.state.isNewCarManagement !== 0) {
			headersDataTable.filter(obj => obj.key === "closedCa").forEach(item => item.header =  "Finding Completed")
		}

		const skeletonRowCount = 10;

		const rows = [];

		if (this.state.auditModel.auditCAR) {
			// Create Ad Hoc DTO
			const cars = this.state.auditModel.auditCAR.sort((a, b) => {
				const sequenceA = new Date(a.progressiveId);
				const sequenceB = new Date(b.progressiveId);
				return sequenceA - sequenceB;
			});
			cars.filter((x) => x.carType == this.state.searchModel.carType).forEach((item) => {
				rows.push({
					id: item.id,
					auditCARCode: item.auditCARCode,
					findingCode: item.findingCode,
					type: item.type,
					status: this.state.isNewCarManagement ? item.status.findingName : item.status.carManagementName,
					owner: item.owner != null ? `${item.owner.name} ${item.owner.surname}` : `${item.ownerSaipem?.name} ${item.ownerSaipem?.surname}`,
					duedate: switchDateFormat(item.dueDate, "date"),
					section: item.section,
					closedCa: this.getCloseCaValue(item),
					recommendedAction: item.recommendedAction,
				});
			});
		}

		const CARModalProps = {
			key: this.state.keyModalCAR,
			maskedValue: this.state.auditModel?.audit?.maskedValue,//RITM1133680 Anonimization_AUDIT_Pending_UI
			title: "Finding" ,
			audit: this.state.auditModel?.audit,
			editModel: this.state.editModelCAR,
			isOpenModal: this.state.isOpenModalCAR,
			isEditModal: this.state.isEditModalCAR,
			toggleModal: this.toggleModalCAR,
			save: this.handleSaveModalCAR,
			appStatus: this.state.appStatus,
			appType: this.state.appType,
			carType: this.state.searchModel.carType,
			isNewCarManagement : this.state.isNewCarManagement,
		};

		const getNameCARById = (id) => {
			if (id == null) return "";
			const element = rows.find((el) => el.id == id);
			return element && element.owner && element.status ? `${element.owner} - ${element.duedate} - ${element.status}` : "";
		};

		const confirmDelProps = () => ({
			idToDelete: this.state.idToDelete,
			nameItem: getNameCARById(this.state.idToDelete),
			isDeleting: this.state.isDeleting,
			open: this.state.isOpenDeleteModal, // open state
			onCloseConfirm: this.onCloseConfirm, // no click
			deleteItem: this.deleteItemCAR, // yes click fn()
		});
		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.rowCount || 0,
			// pageSize: this.state.pageSize || 10,
			//RITM0549692
			pageSize: this.state.pageSize || 20,
			pageSizes: [10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});
		// const audit = this.state.auditModel && this.state.auditModel.audit ? this.state.auditModel.audit : null;
		//RITM0945989
		const buttonTextSFI = this.state.searchModel.carType === CarType.SFI.Code ? '(Not applicable for HSE Audit)' : '';

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
					<Loading active={this.state.isLoadingFindingFile} withOverlay />
						<PageBreadCrumb // Todo fare if in base al ruolo?
							linkTo={`/audit/${this.state.idAuditEdit}`}
							linkText="Audit"
							titleLeft={`Audit Id: ${(this.state.auditModel && this.state.auditModel.auditCode) || ""} - Finding List`}
						/>
						<div className="mainContainer">
							<ConfirmAlertCustom {...confirmDelProps()} />
							{this.showLoading()}
							{this.renderUploadModal()}
							<WFActionModal
								show={this.state.isApprovalModalOpen}
								title={`${this.state.isNewCarManagement? this.state.approvalModalAction.replace('Finding','') : this.state.approvalModalAction} ${this.state.isNewCarManagement? 'Finding' :'Audit CARs'}`}
								action={`${this.state.isNewCarManagement? this.state.approvalModalAction.replace('Finding','') : this.state.approvalModalAction}`}
								withApprover={this.state.withApprover}
								approver={this.state.approver}
								approverRole={this.state.approverRole}
								approverOptions={this.state.approvers}
								isLoadingOperation={this.state.isLoadingWFOperation}
								onApproverSelect={this.handleApproverSelect}
								isLoadingOptions={this.state.isLoadingApproverOptions}
								onCancel={this.handleCloseApprovalModal}
								onConfirm={this.handleConfirmApprovalModal}
								onApprovalNotesChange={this.handleApprovalNotesChange}
								approvalNotes={this.state.approvalNotes}
								approvalNotesRequired={this.state.approvalNotesRequired}
								validationMessages={this.state.approvalValidationMessages}
							/>
							<Tabs
								ariaLabel="listbox"
								className="auditReportTab"
								iconDescription="show menu options"
								onKeyDown={() => {}}
								role="navigation"
								selected={0}
								tabContentClassName="auditReportTab"
								triggerHref="#"
								type="default"
							>
								<Tab
									href="#"
									label="Non Conformity"
									onClick={() => {
										this.updateState("carType", CarType.NC.Code, "searchModel");
										this.getCARs();
									}}
									onKeyDown={() => {}}
									role="presentation"
									selected={false}
									tabIndex={0}
								></Tab>
								<Tab
									href="#"
									label="Observation"
									onClick={() => {
										this.updateState("carType", CarType.OBS.Code, "searchModel");
										this.getCARs();
									}}
									onKeyDown={() => {}}
									role="presentation"
									selected={false}
									tabIndex={1}
								></Tab>
								<Tab
									href="#"
									label="Suggestion For Improvements"
									onClick={() => {
										this.updateState("carType", CarType.SFI.Code, "searchModel");
										this.getCARs();
									}}
									onKeyDown={() => {}}
									role="presentation"
									selected={false}
									tabIndex={2}
								></Tab>
								<Tab
									href="#"
									label="Strength"
									onClick={() => {
										this.updateState("carType", CarType.Strength.Code, "searchModel");
										this.getCARs();
									}}
									onKeyDown={() => {}}
									role="presentation"
									selected={false}
									tabIndex={3}
								></Tab>
							</Tabs>

							<TableToolbar>
								<h3 className="title--medium max-width" />
								{this.state.idAnswer ? (
									(CanExecuteAction("Audit", this.state.isNewCarManagement === 0 ? "CARManagement" : "FindingManagement", user, "", "Create", this.getCanEditResourceId(null)) 
										|| CanExecuteAction("Audit", this.state.isNewCarManagement === 0 ? "CARManagement" : "FindingManagement", user, "", "Create", this.getCanEditByPlanResourceId(null))) && ( //RITM1064131
										<Button onClick={() => this.addCar()} renderIcon={Add16}>
											{/* RITM0945989 */}
											{/* Add new {GetCarTypeByCode(this.state.searchModel.carType).Name} */}
											Add new {GetCarTypeByCode(this.state.searchModel.carType).Name} {buttonTextSFI}
										</Button>
									)
								) : (
									<>
										<Online>
											<FileDownLoadButton
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EXPORTFINDINGS, apioperation.DOWNLOAD));
													}}
													renderIcon={Download16}
													apiUrl={`/audit/${this.state.auditModel.id}/car/excel`}
													fileName={`${"Export_Findings_"}${moment().format("YYYYMMDDHHmmSS")}.xlsx`}
													onDownLoadStart={() => {
														this.setState({
															isSubmitted: true,
														});
													}}
													onDownLoadEnd={() => {
														this.setState({
															isSubmitted: false,
														});
													}}
											>
													Download Findings List
											</FileDownLoadButton>
											<FileDownLoadButton
												onError={(error) => {
													showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CARTEMPLATE, apioperation.DOWNLOAD));
												}}
												renderIcon={Download16}
												apiUrl={`/audit/${this.state.auditModel.id}/car/template`}
												fileName="AuditFindingTemplate.xlsx"
												onDownLoadStart={() => {
													this.setState({
														isSubmitted: true,
													});
												}}
												onDownLoadEnd={() => {
													this.setState({
														isSubmitted: false,
													});
												}}
											>
												Download Template
											</FileDownLoadButton>
											{!this.state.auditModel?.audit?.maskedValue ? ( //RITM1133680
											<Button renderIcon={Export16} onClick={() => this.toggleModalUploadTemplate(true)}>
												Import Findings
											</Button>
											) : null}
										</Online>
										<Offline>
											<FileDownLoadButton renderIcon={Download16} apiUrl={`/audit/${this.state.auditModel.id}/car/template`} fileName="AuditFindingTemplate.xlsx" disabled>
												Download Template
											</FileDownLoadButton>
											{!this.state.auditModel?.audit?.maskedValue ? ( //RITM1133680
											<Button renderIcon={Export16} onClick={() => this.toggleModalUploadTemplate(true)} disabled>
												Import Findings
											</Button>
											) : null}
										</Offline>
									</>
								)}
							</TableToolbar>

							<DataTable
								rows={rows || []}
								headers={headersDataTable}
								useZebraStyles
								size="compact"
								render={({ rows, headers, getHeaderProps, getRowProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
									<TableContainer className="bx--grid--full-width" title="">
										{selectedRows.length > 0 ? (
											<TableToolbar>
												<TableToolbarContent>
													<Online>
														<TableBatchActions {...getBatchActionProps()}>
															{this.state.isNewCarManagement === 0 && this.canSubmitCAR(selectedRows[0].id)  &&
															CanExecuteAction(
																"Audit",
																'CARManagement',
																user,
																selectedRows.length > 0 //&& selectedRows[0].carType == CarType.NC
																	? this.getStatusId(selectedRows[0].id)
																	: null,
																"Submit",
																this.getCanEditResourceId(selectedRows)
															) &&
															this.state.idAnswer != null ? (
																<TableBatchAction renderIcon={Send16} onClick={() => this.batchActionClick('Submit', 'Submit', null, false, false, selectedRows)}>
																	{"Submit FINDING" }
																</TableBatchAction>
															) : null}
															{this.state.isNewCarManagement !== 0 && CanExecuteAction(
																"Audit",
																'FindingManagement',
																user,
																selectedRows.length > 0 //&& selectedRows[0].carType == CarType.NC
																	? this.getStatusId(selectedRows[0].id)
																	: null,
																"Submit",
																this.getCanEditResourceId(selectedRows)
															) && this.canSubmitFinding(selectedRows[0].id) &&
															(	
																<TableBatchAction renderIcon={Send16} onClick={() =>this.batchActionClick('SubmitFinding', 'SubmitFinding', null, false, false, selectedRows)}>
																	{"Submit FINDING"}
																</TableBatchAction>
															)}
															{/* RITM1004125 */}
															{this.state.isNewCarManagement !== 0 &&  CanExecuteAction(
																"Audit",
																'FindingManagement',
																user,
																selectedRows.length > 0 //&& selectedRows[0].carType == CarType.NC
																	? this.getStatusId(selectedRows[0].id)
																	: null,
																"Open",
																this.getCanEditResourceId(selectedRows)
															) && this.canOpenFinding(selectedRows[0].id) && this.getStatusId(selectedRows[0].id) === 3 &&
															(	
																<TableBatchAction renderIcon={Send16} onClick={() =>this.batchActionClick('OpenFinding', 'OpenFinding', null, false, false, selectedRows)}>
																	{"Approve FINDING"}
																</TableBatchAction>
															)}
															{this.state.isNewCarManagement !== 0 &&  CanExecuteAction(
																"Audit",
																'FindingManagement',
																user,
																selectedRows.length > 0 //&& selectedRows[0].carType == CarType.NC
																	? this.getStatusId(selectedRows[0].id)
																	: null,
																"Open",
																this.getCanEditResourceId(selectedRows)
															) && this.canOpenFinding(selectedRows[0].id) && this.getStatusId(selectedRows[0].id) === 5 &&
															(	
																<TableBatchAction renderIcon={Send16} onClick={() =>this.batchActionClick('OpenFinding', 'OpenFinding', null, false, false, selectedRows)}>
																	{"Open FINDING"}
																</TableBatchAction>
															)}
															{/* End */}
															{this.state.isNewCarManagement === 0 && this.canApproveCAR(selectedRows[0].id) &&
															CanExecuteAction(
																"Audit",
																'CARManagement',
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Approve",
																this.getCanEditResourceId(selectedRows)
															) &&
															this.state.idAnswer != null ? (
																<TableBatchAction renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Approve", "Approve", null, false, false, selectedRows)}>
																	{"Approve FINDING"}
																</TableBatchAction>
															) : null}

															{this.state.isNewCarManagement === 0 && this.canCloseCAR(selectedRows[0].id) &&
															CanExecuteAction(
																"Audit",
																'CARManagement',
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Consolidate",
																this.getCanEditResourceId(selectedRows)
															) &&
															this.state.idAnswer != null ? (
																<TableBatchAction renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Close", "Close", null, false, false, selectedRows)}>
																	{"Close FINDING"}
																</TableBatchAction>
															) : null}

															{this.state.isNewCarManagement !== 0 && CanExecuteAction(
																"Audit",
																"FindingManagement",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Close",
																this.getCanEditResourceId(selectedRows)
															) && 
															(
																<TableBatchAction renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("CloseFinding", "CloseFinding", null, false, false, selectedRows)}>
																	{"Close FINDING"}
																</TableBatchAction>
															)}

															{CanExecuteAction(
																"Audit",
																this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement',
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Reject",
																this.getCanEditResourceId(selectedRows)
															) && this.state.idAnswer != null ? (
																<TableBatchAction renderIcon={Error16} onClick={() => this.isNewCarManagement === 0 ? this.batchActionClick("Reject", "Reject", null, false, true, selectedRows) : this.batchActionClick("RejectFinding", "RejectFinding", null, false, true, selectedRows)}>
																	{this.state.isNewCarManagement === 0 ? "Reject FINDING" : "Reject"}
																</TableBatchAction>
															) : null}

															{this.state.isNewCarManagement !== 0 && CanExecuteAction(
																	'Audit',
																	'FindingManagement',
																	user,
																	selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																	'Complete',
																	this.getCanEditResourceId(selectedRows) && this.canCloseFinding(selectedRows[0].id)
																) ? (
																	<Button
																	renderIcon={CheckmarkOutline16}
																	onClick={() => this.batchActionClick('CompleteFinding', 'CompleteFinding', null, false, false, selectedRows)}
																	>
																	{"Complete FINDING"}
																	</Button>
															) : null}

															{(CanExecuteAction(
																"Audit",
																this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement',
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Delete",
																this.getCanEditResourceId(selectedRows)) ||
																CanExecuteAction(
																	"Audit",
																	this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement',
																	user,
																	selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																	"Delete",
																	this.getCanEditByPlanResourceId(selectedRows)) //RITM1064131
															) && !this.state.auditModel?.audit?.maskedValue ? ( //RITM1133680
																<TableBatchAction renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, selectedRows)}>
																	Delete
																</TableBatchAction>
															) : null}
														</TableBatchActions>
													</Online>
												</TableToolbarContent>
											</TableToolbar>
										) : (
											""
										)}

										{this.state.isLoading ? (
											<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
										) : (
											<Table>
												<TableHead>
													<TableRow>
														<TableHeader className="align-center" />

														{headers.map((header) => (
															<TableHeader className={header.type == "bool" ? "align-center" : ""} {...getHeaderProps({ header })}>
																{header.header}
															</TableHeader>
														))}
														<TableHeader className="align-center">Actions</TableHeader>
													</TableRow>
												</TableHead>
												<TableBody>
													{rows == null || rows.length == 0 ? (
														<NoRecordsPlaceholder colSpan={headers.length + 2} />
													) : (
														rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																<Online>
																	{this.IsRowSelectable(row, selectedRows) ? (
																		<TableSelectRow {...getSelectionProps({ row })} />
																	) : (
																		<TableCell key={`empty${row.id}`} className="tableActions align-center" />
																	)}
																</Online>
																<Offline>
																	{this.IsRowSelectable(row, selectedRows) ? (
																		<TableSelectRow {...getSelectionProps({ row })} disabled />
																	) : (
																		<TableCell key={`empty${row.id}`} className="tableActions align-center" />
																	)}
																</Offline>
																{row.cells.map((cell) => (
																	<RenderDataTableCell key={cell.id} cell={cell} header={headers.find((x) => x.key === cell.info.header)} />
																))}

																<TableCell key={`action-${row.id}`} className="tableActions align-center">
																		<div>
																			{(IsEditable("Audit", this.state.isNewCarManagement === 0 ? "CARManagement" : "FindingManagement", user, this.getStatusId(row.id), "All", this.getCanEditResourceId(null)) 
																				|| IsEditable("Audit", this.state.isNewCarManagement === 0 ? "CARManagement" : "FindingManagement", user, this.getStatusId(row.id), "All", this.getCanEditByPlanResourceId(null))) && !this.state.auditModel?.audit?.maskedValue ? ( //RITM1133680 RITM1064131
																				<Button onClick={() => this.editModalCAR(row.id)} size="small" renderIcon={Edit16} iconDescription="Edit" kind="ghost" />
																			) : null}
																			<Link to={this.getUrlDetailCar(row.id)}>
																				<Button size="small" renderIcon={View16} iconDescription="Detail" kind="ghost" />
																			</Link>
																			<Online>
																				<FileDownLoadButton
																					onError={(error) => {
																						showNotification.error(getError(error, entitiesLabels.AUDIT_FINDING, apioperation.DOWNLOAD));
																					}}
																					size="small"
																					iconDescription="Download Finding"
																					title="Download Finding"
																					renderIcon={ExportDoc16}
																					kind="ghost"
																					apiUrl={this.getUrlExportCar(row.id)}
																					fileName={`Audit_Finding_${row.cells[0].value}.zip`}
																					onDownLoadStart={() => {
																						this.setState({
																							isLoadingFindingFile: true,
																						});
																					}}
																					onDownLoadEnd={() => {
																						this.setState({
																							isLoadingFindingFile: false,
																						});
																					}}
																				>
																				</FileDownLoadButton>
																			</Online>
																		</div>
																</TableCell>
															</TableRow>
														))
													)}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								)}
							/>
							<div className="footer-pagination">
								<Pagination {...paginationProps()} />
							</div>
							<AuditCARModal {...CARModalProps} />
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
